<template>
    <el-card class="box-card">
        <el-row>
            <SearchBox ref="SearchBox">
                <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                         class="unitWidth" size="small">
                    <el-form-item label="所属工厂">
                        <el-select v-model="mechanism.fcCode" placeholder="请选择" :clearable="isclear" :disabled="ischeck"
                                   filterable @change="fcChange">
                            <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label"
                                       :value="factory.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属车间">
                        <el-select v-model="mechanism.shopCode" placeholder="请选择" clearable filterable
                                   @change="shopChange">
                            <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label"
                                       :value="shop.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属工段">
                        <el-select v-model="mechanism.sectionCode" placeholder="请选择" clearable filterable
                                   @change="sectionChange">
                            <el-option v-for="section in sectionList" :key="section.value" :label="section.label"
                                       :value="section.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属产线">
                        <el-select v-model="mechanism.lineCode" placeholder="请选择" clearable filterable
                                   @change="lineChange">
                            <el-option v-for="line in lineList" :key="line.value" :label="line.label"
                                       :value="line.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="设备编号" :required="true">
                        <el-select v-model="searchParams.devCode" placeholder="请选择设备编号" clearable filterable>
                            <el-option v-for="dev in deviceInfoList" :key="dev.devId" :label="dev.devCode" :value="dev.devCode"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="选择日期" :required="true">
                        <el-date-picker
                            style="width: 20vw"
                            type="daterange"
                            v-model="dataTime"
                            @change="getStatistics"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            show-week-numbers
                            placement="bottom-end"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item style="margin-left: 20px">
                        <el-button type="primary" @click="getStatistics">查询</el-button>
                        <el-button type="primary" @click="exportDeviceOpcOee" style="margin-left: 10px">导出</el-button>
                    </el-form-item>
                </el-form>
            </SearchBox>
        </el-row>
        <el-row>
            <el-tabs type="border-card">
                <el-tab-pane label="设备OEE信息">
                    <el-table stripe :data="tableData" class="center">
                        <!--                <el-table-column type="selection" width="55" />-->
                        <el-table-column prop="fcName" label="工厂" show-overflow-tooltip/>
                        <el-table-column prop="shopName" label="车间"/>
                        <el-table-column prop="sectionName" label="工段" show-overflow-tooltip/>
                        <el-table-column prop="lineName" label="产线"/>
                        <el-table-column prop="devCode" label="设备编号" width="120"/>
                        <el-table-column prop="devName" label="设备名称" width="120"/>
                        <el-table-column prop="shiftDate" label="班次日期" show-overflow-tooltip width="110"/>
                        <el-table-column prop="sfName" label="班次" show-overflow-tooltip/>
                        <el-table-column prop="planRunTime" label="计划运行时间(分)" show-overflow-tooltip width="130"/>
                        <el-table-column prop="actualRunTime" label="实际运行时间(分)" show-overflow-tooltip width="130"/>
                        <el-table-column prop="planNumber" label="计划数量(个)" show-overflow-tooltip/>
                        <el-table-column prop="actualNumber" label="实际数量(个)" show-overflow-tooltip/>
                        <el-table-column prop="okNumber" label="良品数量(个)" show-overflow-tooltip/>
                        <el-table-column prop="nokNumber" label="不良数量(个)" show-overflow-tooltip/>
                        <el-table-column prop="shiftOee" label="OEE数值" show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span>{{ scope.row.shiftOee }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip/>
                    </el-table>
                    <el-pagination
                        @size-change="paginationChange"
                        @current-change="paginationCurrentChange"
                        :current-page="searchParams.pageNumber"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="searchParams.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="searchParams.total"
                    />
                </el-tab-pane>
                <el-tab-pane label="图表">
                    <div id="main"></div>
                </el-tab-pane>
            </el-tabs>
        </el-row>
    </el-card>
</template>
<script>
    import { getOEEStatistics, getOEEListStatistics } from '../../../api/reportform.js'
    import moment from 'moment'
    import { getDeviceOpcOee } from '../../../libs/api'

    const { export_json_to_excel } = require('../../vendor_excel/Export2Excel')
    // 引入基本模板
    let echarts = require('echarts/lib/echarts')
    // 引入柱状图组件
    require('echarts/lib/chart/bar')
    // 引入提示框和title组件
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')
    require('echarts/lib/component/legend')

    export default {
        name: 'OeeReport',
        data: function() {
            return {
                mechanism: {
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: ''
                },
                searchParams: {
                    pageSize: 10,
                    pageNumber: 1,
                    total: 0,
                    fcCode: '',
                    shopCode: '',
                    sectionCode: '',
                    lineCode: '',
                    devCode: '',
                    startTime: '',
                    endTime: ''

                },
                isclear: false,
                factoryData: [],
                access: [],
                role: [],
                ischeck: true,
                scopeDisabled: '',
                factoryTree: [],
                addShow: false,
                userInfo: {},
                fcIdSelected: '',
                twoAnalyze: [],
                dataTime: [],
                tableData: [],
                mainOrderList: [],
                excelData: [],
                deviceInfoList: []
            }
        },
        computed: {
            factoryList: function() {
                var arr = []
                var userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
                if (this.factoryTree != undefined && this.factoryTree.length > 0) {
                    if (this.ischeck) {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            for (let j = 0; j < userInfo.roles.length; j++) {
                                if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                                    arr.push({
                                        label: this.factoryTree[i].deptName,
                                        id: this.factoryTree[i].deptID,
                                        value: JSON.stringify(this.factoryTree[i]),
                                        deptLevel: this.factoryTree[i].deptLevel,
                                        parent: 0
                                    })
                                }
                            }
                        }
                    } else {
                        for (var i = 0; i < this.factoryTree.length; i++) {
                            arr.push({
                                label: this.factoryTree[i].deptName,
                                id: this.factoryTree[i].deptID,
                                value: JSON.stringify(this.factoryTree[i]),
                                deptLevel: this.factoryTree[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            shopList: function() {
                var arr = []
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode.length > 0) {

                    var factory = JSON.parse(this.mechanism.fcCode)
                    var shops = factory.child
                    for (var i = 0; i < shops.length; i++) {
                        if (shops[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: shops[i].deptName,
                                id: shops[i].deptID,
                                value: JSON.stringify(shops[i]),
                                deptLevel: shops[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            sectionList: function() {
                var arr = []
                if (this.mechanism.shopCode != undefined && this.mechanism.shopCode.length > 0) {
                    var shop = JSON.parse(this.mechanism.shopCode)
                    var vsms = shop.child
                    for (var i = 0; i < vsms.length; i++) {
                        if (vsms[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: vsms[i].deptName,
                                id: vsms[i].deptID,
                                value: JSON.stringify(vsms[i]),
                                deptLevel: vsms[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            },
            lineList: function() {
                var arr = []
                if (this.mechanism.sectionCode != undefined && this.mechanism.sectionCode.length > 0) {
                    var vsm = JSON.parse(this.mechanism.sectionCode)
                    var lines = vsm.child
                    for (var i = 0; i < lines.length; i++) {
                        if (lines[i].hasOwnProperty('deptCode')) {
                            arr.push({
                                label: lines[i].deptName,
                                id: lines[i].deptID,
                                value: JSON.stringify(lines[i]),
                                deptLevel: lines[i].deptLevel,
                                parent: 0
                            })
                        }
                    }
                }
                return arr
            }
        },
        mounted() {
            this.init()
        },
        methods: {
            init: function() {
                this.access = JSON.parse(sessionStorage.getItem('auths'))
                // this.userInfo = sessionStorage.getItem("userInfo")
                this.userInfo = this.$store.state.userInfo
                var role = this.userInfo.roles
                for (var i = 0; i < role.length; i++) {
                    //所有工厂数据
                    if (role[i].factoryId == 0) {
                        this.ischeck = false
                        this.role = role[i]
                        this.scopeDisabled = false
                        this.isclear = true
                        break
                    } else {
                        if (this.userInfo.factoryId == role[i].factoryId) {
                            this.role = role[i]
                        }
                    }
                }
                // this.getFactory()
                this.getData()
            },
            getDeviceOpcOee() {
                let queryParams = {}
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode != '') {
                    queryParams['fcCode'] = JSON.parse(this.mechanism.fcCode).deptCode
                } else {
                    return
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getDeviceOpcOee,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        if (response.data) {
                            this.searchParams.devCode = response.data[0].devCode
                            this.getStatistics()
                        }
                    }
                })
            },
            getDeviceInfoList() {
                let queryParams = {}
                if (this.mechanism.fcCode != undefined && this.mechanism.fcCode != '') {
                    queryParams['fcCode'] = JSON.parse(this.mechanism.fcCode).deptCode
                } else {
                    return
                }
                let options = {
                    method: 'GET',
                    url: this.$api.deviceInfoList,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.deviceInfoList = response.data
                        this.getDeviceOpcOee()
                    }
                })
            },
            async exportDeviceOpcOee() {
                var self = this
                var querydata = {
                    pageNumber: self.searchParams.pageNumber,
                    pageSize: self.searchParams.pageSize
                }
                if (self.searchParams.devCode != '' && undefined != self.searchParams.devCode) {
                    querydata['devCode'] = self.searchParams.devCode
                }
                if (self.dataTime != null && self.dataTime != '') {
                    if (self.dataTime.length > 0 && self.dataTime[0] != '') {
                        querydata['startTime'] = self.dateFormat(self.dataTime[0]) + ' 00:00:00'
                        querydata['endTime'] = self.dateFormat(self.dataTime[1]) + ' 23:59:59'
                    }
                } /*else {
                    self.searchParams.startTime = ''
                    self.searchParams.endTime = ''
                    self.$message.error('请输入开始时间跟结束时间！')
                    return
                  }*/
                if (self.mechanism.fcCode != undefined && self.mechanism.fcCode != '') {
                    querydata['fcCode'] = JSON.parse(self.mechanism.fcCode).deptCode
                }
                if (self.mechanism.shopCode != undefined && self.mechanism.shopCode != '') {
                    querydata['shopCode'] = JSON.parse(self.mechanism.shopCode).deptCode
                }
                if (self.mechanism.sectionCode && self.mechanism.sectionCode != '') {
                    querydata['sectionCode'] = JSON.parse(self.mechanism.sectionCode).deptCode
                }
                if (self.mechanism.lineCode != undefined && self.mechanism.lineCode != '') {
                    querydata['lineCode'] = JSON.parse(self.mechanism.lineCode).deptCode
                }
                let options = {
                    method: 'POST',
                    data: self.searchParams,
                    url: this.$api.exportDeviceOpcOee,
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json;application/ms-excel;application/ms-excel;charset=utf-8'
                    }
                }
                let result = await this.$http.request(options)
                var elink = document.createElement('a')
                elink.download = 'OEE统计'  //设置名称
                elink.style.display = 'none'
                var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)  //追加节点
                elink.click()
                document.body.removeChild(elink)  //删除节点
            },
            getStatistics: function() {
                var self = this
                var querydata = {
                    pageNumber: self.searchParams.pageNumber,
                    pageSize: self.searchParams.pageSize
                }
                if (self.searchParams.devCode != '' && undefined != self.searchParams.devCode) {
                    querydata['devCode'] = self.searchParams.devCode
                }
                if (self.dataTime != null && self.dataTime != '') {
                    if (self.dataTime.length > 0 && self.dataTime[0] != '') {
                        querydata['startTime'] = self.dateFormat(self.dataTime[0]) + ' 00:00:00'
                        querydata['endTime'] = self.dateFormat(self.dataTime[1]) + ' 23:59:59'
                    }
                } /*else {
                    self.searchParams.startTime = ''
                    self.searchParams.endTime = ''
                    self.$message.error('请输入开始时间跟结束时间！')
                    return
                  }*/
                if (self.mechanism.fcCode != undefined && self.mechanism.fcCode != '') {
                    querydata['fcCode'] = JSON.parse(self.mechanism.fcCode).deptCode
                }
                if (self.mechanism.shopCode != undefined && self.mechanism.shopCode != '') {
                    querydata['shopCode'] = JSON.parse(self.mechanism.shopCode).deptCode
                }
                if (self.mechanism.sectionCode && self.mechanism.sectionCode != '') {
                    querydata['sectionCode'] = JSON.parse(self.mechanism.sectionCode).deptCode
                }
                if (self.mechanism.lineCode != undefined && self.mechanism.lineCode != '') {
                    querydata['lineCode'] = JSON.parse(self.mechanism.lineCode).deptCode
                }
                getOEEListStatistics(querydata).then(function(resp) {
                    if (resp.status == 100) {
                        if (undefined == resp.data.list || null == resp.data.list) {
                            self.tableData = []
                        } else {
                            self.tableData = resp.data.list
                            self.searchParams.total = resp.data.total
                        }
                        self.queryParam = querydata
                    } else {
                        self.$message.error('查询失败!')
                    }
                    self.getOEEStatistics(querydata)
                })
            },
            getOEEStatistics(querydata) {
                let self = this
                getOEEStatistics(querydata).then(function(resp) {
                    if (resp.status == 100) {
                        if (undefined == resp.data || null == resp.data) {
                            self.mainOrderList = []
                        } else {

                            self.mainOrderList = resp.data
                            var option = self.creatObject()
                            if (undefined == self.mainOrderList || self.mainOrderList == null) {
                                return
                            }
                            option.legend = {
                                show: true,
                                data: ['早班OEE', '晚班OEE'],
                                selected: {
                                    '早班OEE': true,
                                    '晚班OEE': true
                                }
                            }
                            option.series = [
                                { name: '早班OEE', type: 'bar', data: [] },
                                { name: '晚班OEE', type: 'bar', data: [] }
                            ]
                            for (var key in self.mainOrderList) {
                                option.xAxis[0].data.push(key)
                                option.series[0].data.push(String(parseFloat(self.mainOrderList[key].dayShiftOee) * 100).substring(0, String(parseFloat(self.mainOrderList[key].dayShiftOee) * 100).indexOf('.') + 3))
                                option.series[1].data.push(String(parseFloat(self.mainOrderList[key].eveningShiftOee == undefined ? 0 : self.mainOrderList[key].eveningShiftOee) * 100).substring(0, String(parseFloat(self.mainOrderList[key].dayShiftOee == undefined ? 0 : self.mainOrderList[key].eveningShiftOee) * 100).indexOf('.') + 3))
                            }
                            self.drawLine(option)

                        }
                        self.queryParam = querydata
                    } else {
                        self.$message.error('查询失败!')
                    }
                })
            },
            drawLine(option) {
                // 基于准备好的dom，初始化echarts实例
                let myChart = echarts.init(document.getElementById('main'))
                // 绘制图表
                myChart.setOption(option)
            },
            creatObject: function() {
                var option = {
                    title: { text: 'OEE统计' },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                        }
                    },
                    toolbox: {
                        show: true,
                        orient: 'vertical',
                        x: 'right',
                        y: 'center',
                        feature: {
                            mark: { show: true },
                            dataView: { show: true, readOnly: false },
                            magicType: { show: true, type: ['line', 'bar', 'stack', 'tiled'] },
                            restore: { show: true },
                            saveAsImage: { show: true }
                        }
                    },
                    grid: {
                        left: '10%',
                        bottom: '35%'
                    },
                    calculable: true,
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisLabel: {
                            interval: 0,//横轴信息全部显示
                            rotate: 40//-30度角倾斜显示
                        }
                    }],
                    yAxis: [{
                        type: 'value',
                        axisLabel: {
                            show: true,
                            interval: 'auto',
                            formatter: '{value} %'
                        },
                        show: true
                    }]
                }
                return option
            },
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.getStatistics()
            },
            paginationCurrentChange(val) {
                this.searchParams.pageNumber = val
                this.getStatistics()
            },
            fcChange: function() {
                this.mechanism.shopCode = ''
                this.mechanism.sectionCode = ''
                this.mechanism.lineCode = ''
                this.searchParams.devCode = ''
                this.getDeviceInfoList()
            },
            shopChange: function() {
                this.mechanism.sectionCode = ''
                this.mechanism.lineCode = ''
            },
            sectionChange: function() {
                this.mechanism.lineCode = ''
            },
            lineChange: function() {
            },
            getFactory() {
                let queryParams = {
                    fcCode: this.userInfo.fcCode
                }
                let options = {
                    methods: 'GET',
                    url: this.$api.getAllFactory,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.factoryData = response.data
                    }
                })
            },
            getData() {
                var self = this
                let options = {
                    method: 'GET',
                    url: this.$api.departTree
                }
                this.$http.request(options).then(response => {
                    this.factoryTree = response.data
                    for (var i = 0; i < self.factoryTree.length; i++) {
                        if (self.factoryTree[i].deptID == self.role.factoryId) {
                            self.mechanism.fcCode = JSON.stringify(self.factoryTree[i])
                        }
                    }
                    this.getDeviceInfoList()
                })
            },
            getdatarange: function() {
                this.searchParams.startTime = ''
                this.searchParams.endTime = ''
                if (this.dataTime != null && this.dataTime != '') {
                    if (this.dataTime.length > 0 && this.dataTime[0] != '') {
                        this.searchParams.startTime = this.dataTime[0] + ' 00:00:00'
                        this.searchParams.endTime = this.dataTime[1] + ' 23:59:59'
                    }
                } else {
                    this.searchParams.startTime = ''
                    this.searchParams.endTime = ''
                }
                this.dateRange = this.data
            },
            dateFormat(date) {
                return moment(date).format('YYYY-MM-DD')
            },
            DeviceExcel: function() {
                var self = this
                self.excelData = []

                for (var key in self.mainOrderList) {
                    var data = {
                        dateTime: key,
                        dayShiftOee: String(parseFloat(self.mainOrderList[key].dayShiftOee) * 100).substring(0, String(parseFloat(self.mainOrderList[key].dayShiftOee) * 100).indexOf('.') + 3) + '%',
                        eveningShiftOee: String(parseFloat(self.mainOrderList[key].eveningShiftOee) * 100).substring(0, String(parseFloat(self.mainOrderList[key].dayShiftOee) * 100).indexOf('.') + 3) + '%'
                    }
                    self.excelData.push(data)
                }
                self.DeviceExport()
            },
            formatJson: function(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            DeviceExport: function() {
                const tHeader = ['日期', '白班OEE', '晚班OEE']
                const filterVal = ['dateTime', 'dayShiftOee', 'eveningShiftOee']
                export_json_to_excel(tHeader, this.formatJson(filterVal, this.excelData), 'OEE统计')
            }


        }
    }
</script>
<style lang="scss" scoped>
    .box-card {
        width: 70%;
    }

    #main {
        width: 1200px;
        height: 700px;
    }
</style>
